import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_5 = { class: "card-body pt-0" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("LoginHistory.BlockList")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Datatable, {
        "table-data": _ctx.tableData,
        "table-header": _ctx.tableHeader,
        "enable-items-per-page-dropdown": true,
        "rows-per-page": 50
      }, {
        "cell-block": _withCtx(({ row: history }) => [
          _createElementVNode("button", {
            class: "btn btn-success",
            onClick: ($event: any) => (_ctx.unblockIP(history))
          }, [
            _hoisted_7,
            _createTextVNode(_toDisplayString(_ctx.$t("LoginHistory.Unblock")), 1)
          ], 8, _hoisted_6)
        ]),
        _: 1
      }, 8, ["table-data", "table-header"])
    ])
  ]))
}